module.exports = __webpack_public_path__ + "media/onakasuita.1385ef76.mp3";